import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { ArrowLeft, Sparkles } from "lucide-react";
import { WhatsAppFloat } from "../components/sections/WhatsAppFloat";

export default function Blog() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#041209] text-slate-100 flex flex-col" data-testid="blog-page">
      <div className="flex-1 flex items-center justify-center px-5 py-20">
        <div className="max-w-2xl text-center">
          <div className="kd-chip mx-auto mb-6 inline-flex">
            <Sparkles className="w-3.5 h-3.5" />
            KisanDrone Blog
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            {t("blog.title")}
          </h1>
          <p className="mt-5 text-lg text-slate-300">{t("blog.subtitle")}</p>
          <Link
            to="/"
            className="mt-10 kd-btn-gold px-6 py-3.5 rounded-full font-semibold text-sm inline-flex items-center gap-2"
            data-testid="blog-back-btn"
          >
            <ArrowLeft className="w-4 h-4" /> {t("blog.back")}
          </Link>
        </div>
      </div>
      <WhatsAppFloat />
    </div>
  );
}
